import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const checkVerificationCodeReducer = createReducer<State, Actions>(initialState, {
  [actions.checkVerificationCode.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.checkVerificationCode.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.checkVerificationCode.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.checkVerificationCode.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default checkVerificationCodeReducer;
